import { Variable } from '@mtna/pojo-consumer-ts';
import { VariableSummary } from '@mtna/variable-service-core-ts';

import { RdsNullFilter } from './null-filter.model';

export class BaseFilter<V extends Variable | VariableSummary = Variable> {
  constructor(public variable: V, public nullFilter?: RdsNullFilter) {}
}
